module.exports = __webpack_public_path__ + "img/empty_events.35b0a0b4.png";